
export function escapeQuotes(text:string):string {
    const escapedDoubleQuote = text.replace('"', '"');
    const escapedSingleQuote = escapedDoubleQuote.replace("'", "'");
    //return escapedSingleQuote;
    return text;
}